import React from 'react';
import "./politicadeprivacidade.css";

export default function PoliticaDePrivacidade() {
  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <h1>Política de Privacidade</h1>
        <p className="last-updated">Última atualização: Fevereiro 2025</p>
      </header>
      
      <main className="privacy-content">
        <section className="privacy-section">
          <h2>Resumo</h2>
          <div className="privacy-card primary">
            <p>Sua privacidade é importante para nós. Atualmente, não coletamos nenhuma informação pessoal dos visitantes deste site.</p>
          </div>
        </section>
        
        <section className="privacy-section">
          <h2>Coleta de Dados</h2>
          <div className="privacy-card">
            <p>Não coletamos, armazenamos ou compartilhamos qualquer informação pessoal dos visitantes do nosso site.</p>
            <ul className="privacy-list">
              <li>Não usamos cookies de rastreamento</li>
              <li>Não coletamos informações de identificação pessoal</li>
              <li>Não armazenamos dados de navegação</li>
            </ul>
          </div>
        </section>

        <section className="privacy-section">
          <h2>Uso de Cookies</h2>
          <div className="privacy-card">
            <p>Nosso site utiliza cookies para melhorar a experiência do usuário. No entanto, não usamos cookies para coletar informações pessoais ou identificar nossos visitantes.</p>
            <p>Os cookies que utilizamos são temporários e são excluídos automaticamente após a sessão de navegação.</p>
          </div>
        </section>

        <section className="privacy-section">
          <h2>Informações de Terceiros</h2>
          <div className="privacy-card">
            <p>Nosso site pode conter links para sites de terceiros. Não somos responsáveis pelas práticas de privacidade desses sites. Recomendamos que você leia as políticas de privacidade de qualquer site de terceiros que você visite.</p>
            <p>Se você tiver dúvidas sobre essas práticas, entre em contato diretamente com os terceiros envolvidos.</p>
          </div>
        </section>
        
        <section className="privacy-section">
          <h2>Alterações nesta Política</h2>
          <div className="privacy-card">
            <p>Esta política de privacidade pode ser atualizada de tempos em tempos. Qualquer mudança será publicada nesta página.</p>
            <div className="alert-box">
              <strong>Nota:</strong> Recomendamos verificar esta página periodicamente para ficar informado sobre possíveis alterações.
            </div>
          </div>
        </section>
        
        <section className="privacy-section">
          <h2>Contate-Nos</h2>
          <div className="privacy-card contact">
            <p>Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco:</p>
            <div className="contact-info">
              <a href="mailto:felipedequadrosgomes18@gmail.com" className="email-link">
                felipedequadrosgomes18@gmail.com
              </a>
              <p>Esta política de privacidade está em conformidade com a LGPD e outras leis aplicáveis.</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
